<template>
  <div class="flex flex-col gap-2">
    <label v-if="label" :for="inputId" class="font-medium text-text-primary text-[14px]">
      {{ label }}
      <span v-if="required" class="text-red">*</span>
    </label>
    <div
      class="flex items-center border-2 rounded-xl transition-colors duration-200 bg-white"
      :class="{
        'border-red focus-within:border-red': !!error,
        'border-border focus-within:border-primary': !error,
      }"
    >
      <div class="flex items-center gap-2 px-3 py-3 border-r-2 border-border">
        <span class="text-text-primary text-[14px]">(+94)</span>
      </div>
      <input
        :id="inputId"
        :type="type"
        :value="modelValue"
        :placeholder="placeholder"
        :disabled="disabled"
        :readonly="readonly"
        :maxlength="maxlength"
        class="flex-1 px-3 py-3 border-none outline-none text-base bg-transparent text-text-primary placeholder:text-text-muted"
        style="font-size: 16px"
        @input="handleInput"
        @blur="handleBlur"
      />
    </div>
    <p v-if="hint && !error" class="text-[14px] text-text-muted m-0">
      {{ hint }}
    </p>
    <span v-if="error" :id="`${inputId}-error`" class="text-red text-[14px]" role="alert">
      {{ error }}
    </span>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

interface Props {
  modelValue: string | number
  label?: string
  placeholder?: string
  disabled?: boolean
  readonly?: boolean
  required?: boolean
  error?: string | undefined
  hint?: string
  id?: string
  type?: 'text' | 'tel' | 'number'
  maxlength?: number
}

const props = withDefaults(defineProps<Props>(), {
  type: 'text',
  disabled: false,
  readonly: false,
  required: false,
})

const emit = defineEmits<{
  'update:modelValue': [value: string | number]
  blur: []
}>()

const inputId = computed(
  () => props.id || `mobile-input-${Math.random().toString(36).substr(2, 9)}`
)

const handleInput = (event: Event): void => {
  const target = event.target as HTMLInputElement
  const cleaned = target.value.replace(/\D/g, '')
  emit('update:modelValue', cleaned)
}

const handleBlur = (): void => {
  emit('blur')
}
</script>
